"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ACCEPT_LANGUAGE: true,
  CLIENT_APPLICATION: true,
  NEAREST_PICKUP_POINTS_FIXED_SIZE: true,
  NOTIFICATIONS_FIXED_SIZE: true,
  PICKUP_POINTS_PAGE_SIZE: true,
  SUGGESTIONS_PAGE_SIZE: true,
  MAP_INFO_FADE_TIMEOUT: true,
  DEBOUNCE_TIMEOUT: true,
  SEARCH_RADIUS: true,
  processContext: true,
  XXS: true,
  ITEM_WIDTH: true,
  ITEM_WIDTH_XS: true,
  ITEM_WIDTH_XXS: true,
  ITEM_HEIGHT: true,
  ITEM_HEIGHT_XS: true,
  ITEM_HEIGHT_XXS: true,
  DOUBLE_CURRENCY_HEIGHT_EXTENSION: true,
  SUBSCRIPTIONS_PAGE_LINK: true
};
exports.processContext = exports.XXS = exports.SUGGESTIONS_PAGE_SIZE = exports.SUBSCRIPTIONS_PAGE_LINK = exports.SEARCH_RADIUS = exports.PICKUP_POINTS_PAGE_SIZE = exports.NOTIFICATIONS_FIXED_SIZE = exports.NEAREST_PICKUP_POINTS_FIXED_SIZE = exports.MAP_INFO_FADE_TIMEOUT = exports.ITEM_WIDTH_XXS = exports.ITEM_WIDTH_XS = exports.ITEM_WIDTH = exports.ITEM_HEIGHT_XXS = exports.ITEM_HEIGHT_XS = exports.ITEM_HEIGHT = exports.DOUBLE_CURRENCY_HEIGHT_EXTENSION = exports.DEBOUNCE_TIMEOUT = exports.CLIENT_APPLICATION = exports.ACCEPT_LANGUAGE = void 0;
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _deliveryOptions = require("./deliveryOptions");
Object.keys(_deliveryOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _deliveryOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _deliveryOptions[key];
    }
  });
});
var _maps = require("./maps");
Object.keys(_maps).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _maps[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _maps[key];
    }
  });
});
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
// Header
const ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'accept-language';
const CLIENT_APPLICATION = exports.CLIENT_APPLICATION = 'x-client-application';
const NEAREST_PICKUP_POINTS_FIXED_SIZE = exports.NEAREST_PICKUP_POINTS_FIXED_SIZE = 4;
const NOTIFICATIONS_FIXED_SIZE = exports.NOTIFICATIONS_FIXED_SIZE = 99;
const PICKUP_POINTS_PAGE_SIZE = exports.PICKUP_POINTS_PAGE_SIZE = 5;
const SUGGESTIONS_PAGE_SIZE = exports.SUGGESTIONS_PAGE_SIZE = 7;
const MAP_INFO_FADE_TIMEOUT = exports.MAP_INFO_FADE_TIMEOUT = 3000;
const DEBOUNCE_TIMEOUT = exports.DEBOUNCE_TIMEOUT = 350;
/** Fixed fallback search radius, in meters. */
const SEARCH_RADIUS = exports.SEARCH_RADIUS = 10000;

// TO-DO: Discuss with Acquisition guys putting this as an enum / literal union type directly into address-form NPM.
const processContext = exports.processContext = 'Delivery';

// UI
// Smallest breakpoint - we should still cover these devices for some time.
// Grid didn't look well without adjustments for these devices.
// In last ori-ui version, it is not possible to add custom breakpoints into the theme (yet).
const XXS = exports.XXS = 360;

// shipping offer grid item sizes
const ITEM_WIDTH = exports.ITEM_WIDTH = 155;
const ITEM_WIDTH_XS = exports.ITEM_WIDTH_XS = 143;
const ITEM_WIDTH_XXS = exports.ITEM_WIDTH_XXS = 129;
const ITEM_HEIGHT = exports.ITEM_HEIGHT = 261;
const ITEM_HEIGHT_XS = exports.ITEM_HEIGHT_XS = 251;
const ITEM_HEIGHT_XXS = exports.ITEM_HEIGHT_XXS = 241;
const DOUBLE_CURRENCY_HEIGHT_EXTENSION = exports.DOUBLE_CURRENCY_HEIGHT_EXTENSION = 20;
const SUBSCRIPTIONS_PAGE_LINK = exports.SUBSCRIPTIONS_PAGE_LINK = '/mypages/order/subscriptions';